import React, { ReactNode, ButtonHTMLAttributes } from 'react';
import styles from './ButtonSkeleton.module.css';

interface ButtonSkeletonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  onClick?: () => void;
  isDisabled?: boolean;
  wrapperClass?: string;
}

const ButtonSkeleton: React.FC<ButtonSkeletonProps> = ({
  children,
  onClick,
  isDisabled = false,
  wrapperClass,
  ...rest
}) => {
  const baseClass = styles.button;

  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={`${baseClass}  ${wrapperClass || ''}`}
      aria-disabled={isDisabled}
      {...rest}
    >
      {children}
    </button>
  );
};

ButtonSkeleton.displayName = 'ButtonSkeleton';

export default ButtonSkeleton;
